import { defineNuxtPlugin } from '#app';
import { useNuxtApp } from '#imports';
import { DateTime } from 'luxon';

export default defineNuxtPlugin(() => ({
    provide: {
        locator: {
            getTodayOpeningHours(openingHours, translator = null) {
                const today = DateTime.now().toFormat('yyyy-MM-dd');

                if (openingHours.store24h) {
                    if (translator) {
                        return translator.t('open24h');
                    }

                    return 'Open 24h';
                } else if (typeof(openingHours.storeOpeningHours) === 'object') {
                    try {
                        const { hours } = openingHours.storeOpeningHours.find(time => time.date === today);

                        return hours.map(item => `${item.opens} - ${item.closes}`).join(', ');
                    } catch (e) {
                        return '-';
                    }
                }

                return '-';
            },
            parseOpenHoursRows(openingHours, translator = null) {
                const translate = translator ? translator.t : (v => v);
                const today = DateTime.now().toFormat('yyyy-MM-dd');
                const tomorrow = DateTime.now().plus({ days: 1 }).toFormat('yyyy-MM-dd');

                if (openingHours.store24h) {
                    return [{
                        label: translate('open24h'),
                    }];
                }

                return openingHours.storeOpeningHours.filter(item => DateTime.fromFormat(item.date, 'yyyy-MM-dd').toMillis() > DateTime.now().minus({ days: 1 }).toMillis()).map(item => ({
                    label: item.date === today
                        ? translate('day.today')
                        : (item.date === tomorrow
                            ? translate('day.tomorrow')
                            : translate(`day.${DateTime.fromFormat(item.date, 'yyyy-MM-dd').toFormat('E')}`)
                        ),
                    hours: item.hours.map(entry => `${entry.opens} - ${entry.closes}`).join(', '),
                }));
            },
            filters() {
                return {
                    stationTypes: {
                        filters: [
                            {
                                icon: 'helmisimpukka-restaurant-filled',
                                code: 'helmisimpukkarestaurant',
                                additive: true,
                                quickFilter: true,
                                quickFilterIcon: 'logo-helmisimpukka-crop',
                                displayOnStationList: true,
                            },
                            {
                                icon: 'restaurant-filled',
                                code: 'helmisimpukka',
                                additive: true,
                                quickFilter: true,
                                quickFilterIcon: 'logo-helmisimpukka-express-crop',
                                displayOnStationList: true,
                            },
                            {
                                icon: '24h-filled',
                                code: 'open24h',
                                quickFilter: true,
                            },
                            {
                                icon: 'car-wash-filled',
                                code: ['perfectcarwash', 'perfectcarwash24hours'],
                            },
                        ],
                    },
                    food: {
                        filters: [
                            {
                                icon: 'restaurant-filled',
                                code: 'lunch',
                                quickFilter: true,
                            },
                            { icon: 'restaurant-filled', code: 'weekendlunch' },
                            { icon: 'coffee-filled', code: 'breakfastbuffet' },
                            { icon: 'hamburger-filled', code: 'drivers' },
                            { icon: 'pizza-filled', code: 'pizza' },
                            { icon: 'hamburger-filled', code: 'driverspremium' },
                            { icon: 'restaurant-filled', code: 'alwaysonoffer' },
                        ],
                    },
                    services: {
                        filters: [
                            { icon: 'self-service-car-wash-filled', code: 'selfservicecarwash' },
                            { icon: 'trailer-filled', code: 'trailerrent' },
                            { icon: 'lorry-filled', code: 'truckfuelingpoint' },
                            { icon: 'shower-filled', code: 'shower' },
                            { icon: 'sauna-filled', code: 'sauna' },
                            { icon: 'caravan-parking-filled', code: 'caravanparking' },
                            { icon: 'service-station-filled', code: 'selfservicepaymentterminal' },
                        ],
                    },
                    fuels: {
                        filters: [
                            { code: 're85' }, { code: 'adblue' }, { code: 'cbg' },
                        ],
                    },
                    otherServices: {
                        filters: [
                            { icon: 'delivery-filled', code: 'post' },
                            { icon: 'delivery-filled', code: 'matkahuolto' },
                            { icon: 'service-station-filled', code: 'atm' },
                            { icon: 'service-station-filled', code: 'veikkaus' },
                            { icon: 'hamburger-filled', code: 'burgerking' },
                            { icon: 'pizza-filled', code: 'kotipizza' },
                            { icon: 'groups-filled', code: 'meetingroom' },
                            { icon: 'delivery-filled', code: 'schenker' },
                            { icon: 'delivery-filled', code: 'budbee' },
                        ],
                    },
                };
            },
            filtersOnStationList() {
                const { $locator } = useNuxtApp();
                const { filters } = $locator.filters().stationTypes;

                return filters.filter(item => item.displayOnStationList).map(item => item.code);
            },
        },
    },
}));

/*
const defaultFilters = {
};

function getAllFilters() {
    return [
        ...defaultFilters.stationTypes,
        ...defaultFilters.food,
        ...defaultFilters.services,
        ...defaultFilters.fuels,
        ...defaultFilters.otherServices,
    ];
}

function findFilterByCode(filterCode) {
    return getAllFilters().find(({ code }) =>
        code.split(',')
            .some(codePart => codePart === filterCode));
}

export {
    defaultFilters,
    findFilterByCode,
    getAllFilters,
};
*/
